import { isBankFundingMethod } from '../bank-transfers/types.js';
export function fundingMethodPolicy(manifest, method) {
    const methods = manifest.onramp.providers.moonpay.methods;
    return isBankFundingMethod(method) ? methods.bank_transfer[method] : methods[method];
}
